import React from 'react'

const MdLeftDir = () => {
  return (
    <svg width="65" height="16" viewBox="0 0 65 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.49812 1.125L1.90771 8L9.49812 14.875M64.011 8.00002H21.422C13.9522 8.00002 9.76411 8.00002 2.29426 8.00002" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
    
  )
}

export default MdLeftDir
